import React from 'react';

const PdfEmbed: React.FunctionComponent<{ src: string }> = ({ src }) => {
    return (
        <iframe
            src={src}
            width="100%"
            height="100%"
            style={{ position: 'absolute', border: 'none' }}
        />
    );
};

export default PdfEmbed;
